// extracted by mini-css-extract-plugin
module.exports = {"taskProgress":"style_taskProgress__11n_F","disabled":"style_disabled__3SUPg"};